"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refillRequestHandlers = exports.postRefillRequestUnregistered = exports.postRefillRequest = void 0;
var instance_1 = require("./instance");
var msw_1 = require("msw");
var mock = {};
function postRefillRequest(refillRequest) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/RefillRequest",
        method: "POST",
        data: refillRequest,
    })
        .then(function (result) { return result.data; });
}
exports.postRefillRequest = postRefillRequest;
mock.postRefillRequest = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/RefillRequest"), function (req, res, ctx) {
        var response = req.body.scriptNumbers.map(function (n, i) { return ({
            scriptNumber: n,
            success: (i + 1) % 3 !== 0,
            message: (i + 1) % 3 !== 0
                ? "Refill for RX#".concat(n, " is being processed.")
                : "A refill has already been requested for RX#".concat(n),
        }); });
        return res(ctx.status(200), ctx.delay(1000), ctx.json(response));
    });
};
function postRefillRequestUnregistered(refillRequest) {
    return (0, instance_1.getInstance)()
        .request({
        url: "/RefillRequest/unregistered",
        method: "POST",
        data: refillRequest,
    })
        .then(function (result) { return result.data; });
}
exports.postRefillRequestUnregistered = postRefillRequestUnregistered;
mock.postRefillRequestUnregistered = function () {
    return msw_1.rest.post("".concat((0, instance_1.getBaseURL)(), "/RefillRequest/unregistered"), function (req, res, ctx) {
        var response = req.body.scriptNumbers.map(function (n, i) { return ({
            scriptNumber: n,
            success: (i + 1) % 3 !== 0,
            message: (i + 1) % 3 !== 0
                ? "Refill for RX#".concat(n, " is being processed.")
                : "A refill has already been requested for RX#".concat(n),
        }); });
        return res(ctx.status(200), ctx.delay(1000), ctx.json(response));
    });
};
exports.refillRequestHandlers = mock;
